import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import DeclarativeAutomationAPI from '../../api/declarativeAutomation';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
    isCloning: false,
  },
};

export const getters = {
  getDeclarativeAutomations(_state) {
    return _state.records.sort((a1, a2) => a1.id - a2.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getDeclarativeAutomations({ commit }) {
    commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isFetching: true });
    try {
      const response = await DeclarativeAutomationAPI.get();
      commit(types.SET_DECLARATIVE_AUTOMATIONS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createDeclarativeAutomation(
    { commit },
    automationObj
  ) {
    commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isCreating: true });
    try {
      const response = await DeclarativeAutomationAPI.create(automationObj);
      commit(types.ADD_DECLARATIVE_AUTOMATION, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await DeclarativeAutomationAPI.update(id, updateObj);
      commit(types.EDIT_DECLARATIVE_AUTOMATION, response.data.payload);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isDeleting: true });
    try {
      await DeclarativeAutomationAPI.delete(id);
      commit(types.DELETE_DECLARATIVE_AUTOMATION, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isDeleting: false });
    }
  },
  clone: async ({ commit }, id) => {
    commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isCloning: true });
    try {
      const response = await DeclarativeAutomationAPI.clone(id);
      commit(types.ADD_DECLARATIVE_AUTOMATION, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DECLARATIVE_AUTOMATION_UI_FLAG, { isCloning: false });
    }
  },
};

export const mutations = {
  [types.SET_DECLARATIVE_AUTOMATION_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_DECLARATIVE_AUTOMATION]: MutationHelpers.create,
  [types.SET_DECLARATIVE_AUTOMATIONS]: MutationHelpers.set,
  [types.EDIT_DECLARATIVE_AUTOMATION]: MutationHelpers.update,
  [types.DELETE_DECLARATIVE_AUTOMATION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
